import React from 'react';

export function PodGridContent(props: React.PropsWithChildren<any>) {

	return (
		<div className='pods-benefits-grid-item-content rich-text'>
			{props.children}
		</div>
	);
}